export interface CachedData<T> {
    data: T;
    timestamp: number;
}

// Default cache duration - 24 hours in milliseconds
export const DEFAULT_CACHE_DURATION = 24 * 60 * 60 * 1000;

export const isCacheValid = (timestamp: number | undefined, cacheDuration: number = DEFAULT_CACHE_DURATION): boolean => {
    if (!timestamp) return false;
    const now = Date.now();
    return now - timestamp < cacheDuration;
};

export const getCachedData = <T>(key: string, cacheDuration: number = DEFAULT_CACHE_DURATION): CachedData<T> | null => {
    try {
        const item = localStorage.getItem(key);
        if (!item) return null;
        
        const cached = JSON.parse(item) as CachedData<T>;
        if (!isCacheValid(cached.timestamp, cacheDuration)) {
            localStorage.removeItem(key);
            return null;
        }
        
        return cached;
    } catch {
        return null;
    }
};

export const setCachedData = <T>(key: string, data: T): void => {
    const cacheData: CachedData<T> = {
        data,
        timestamp: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
};
